<template>
  <v-dialog v-model="active" max-width="380" @click:outside="onClose" content-class="auth--dialog">
    <v-card>
      <v-row cols="12" no-gutters>
        <!-- <v-col cols="12" md="6" class="d-none d-md-flex">
				<v-img class="fill-height d-flex align-center" width="100%" :src="require('../assets/login-popup-bg.jpg')">
					<div class="d-flex pa-5">
						<h2 class="display-2 white--text" v-if="tab == 0">{{ trans('app.sign_up_title') }}</h2>
						<h2 class="display-2 white--text" v-if="tab == 1">{{ trans('app.sign_in_title') }}</h2>
					</div>
				</v-img> 
        </v-col>-->

        <v-col cols="12" md="12">
          <v-tabs v-model="active_tab" grow>
            <v-tabs-slider></v-tabs-slider>

            <v-tab>
              <div class="py-8">{{ trans('app.sign_up') }}</div>
            </v-tab>
            <v-tab>
              <div class="py-8">{{ trans('app.sign_in') }}</div>
            </v-tab>

            <v-tab-item :key="0">
              <auth ref="sign_up_tab" mode="sign_up"></auth>
            </v-tab-item>
            <v-tab-item :key="1">
              <auth ref="sign_in_tab" mode="sign_in" @login="emitLogin"></auth>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Auth from "../components/Auth";

export default {
  components: {
    auth: Auth
  },
  props: ["active", "tab"],
  computed: {
    active_tab: {
      get: function() {
        return this.$props.tab;
      },
      set: function(v) {
        this.onChange(v);
        try {
          this.$refs.sign_up_tab.resetFields();
          this.$refs.sign_in_tab.resetFields();
        } catch (e) {}
      }
    }
  },
  methods: {
    onClose: function(e) {
      return this.$emit("close");
    },
    onChange: function(v) {
      return this.$emit("change", v);
    },
    emitLogin: function(e) {
      return this.$emit("login", e);
    }
  }
};
</script>
